import { useContext, useState } from 'react';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import { AdminPartners } from '@platform/client';
import { AdminTableContext } from '../../AdminTable';
import { checkPartnerUrlParamUnique, PartnerForm, PartnerFormData } from './PartnersForm';
type CreatePartnerModalProps = {
  onClose: () => void;
};

export const CreatePartnerModal = (props: CreatePartnerModalProps) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const { ...functions } = useForm<PartnerFormData>();
  const queryClient = useQueryClient();
  const createPartnerMutator = AdminPartners.useCreateImpactPartner({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => {
        setModalStage('error');
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...AdminPartners.getGetAdminPartnersQueryKey({ ...adminQueryOptionsV2 })],
        });
        setModalStage('success');
      },
    },
  });
  const onSubmit: SubmitHandler<PartnerFormData> = async (data) => {
    if (data.urlParam) {
      const urlParamIsUnique = await checkPartnerUrlParamUnique(data.urlParam, null);
      if (!urlParamIsUnique) {
        functions.setError('urlParam', { type: 'manual', message: 'Url param already exists' });
        return;
      } else {
        functions.clearErrors('urlParam');
      }
    }
    createPartnerMutator.mutate({
      data: {
        name: data.name,
        description: data.description,
        logo: data.logo,
        link: data.link,
        active: data.active ?? false,
        urlParameter: data.urlParam ?? null,
        linkedinUrl: data.linkedinUrl ?? null,
      },
    });
  };
  return (
    <AdminFormModal
      variant='full-screen'
      title='Create Partner'
      modalStage={modalStage}
      onClose={props.onClose}
      submitCTA={{ text: 'Save', callback: () => functions.handleSubmit(onSubmit)() }}
    >
      <PartnerForm {...functions} />
    </AdminFormModal>
  );
};
